
















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class ReferralProgramIcon extends Vue {
  @Prop({ default: '48' }) readonly width?: string;
  @Prop({ default: '48' }) readonly height?: string;
  @Prop({ default: '#8D949E' }) readonly fill?: string;
}
